
import { Component, Vue } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, numeric, alphaNum, integer } from "vuelidate/lib/validators";

@Component
export default class MixinPurposeEditDialogValidator extends Vue {
  @Validations()
  validations = {
    item: {
      //送料無料条件
      freeShippingLine: { required, numeric },
      //purposeNo
      purposeNo: { numeric },
      //名称
      name: { required },
      //カテゴリ名称
      categoryName: { required },
      //スラッグ名称
      slugName: { required, alphaNum },
      //表示順
      displayOrder: { required, integer },
    },
  };
  //---------------------------
  // methods
  //---------------------------

  /**
   * 名称の入力エラーメッセージを返します.
   */
  get nameErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.name?.$dirty) return errors;
    !this.$v.item.name?.required && errors.push("名称を入力してください.");
    return errors;
  }
  /**
   * カテゴリ名称の入力エラーメッセージを返します.
   */
  get categoryNameErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.categoryName?.$dirty) return errors;
    !this.$v.item.categoryName?.required &&
      errors.push("カテゴリ名称を入力してください.");
    return errors;
  }
  /**
   * スラッグ名称の入力エラーメッセージを返します.
   */
  get slugNameErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.slugName?.$dirty) return errors;
    !this.$v.item.slugName?.required &&
      errors.push("スラッグ名称を入力してください.");
    !this.$v.item.slugName?.alphaNum &&
      errors.push("スラッグ名称は半角英数字のみです.");
    return errors;
  }
  /**
   * 表示順の入力エラーメッセージを返します.
   */
  get displayOrderErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.displayOrder?.$dirty) return errors;
    !this.$v.item.displayOrder?.required &&
      errors.push("表示順を入力してください.");
    !this.$v.item.displayOrder?.integer && errors.push("表示順は数値のみです.");
    return errors;
  }
  /**
   * 送料無料条件（円以上）の入力エラーメッセージを返します.
   */
  get freeShippingLineErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.freeShippingLine?.$dirty) return errors;
    !this.$v.item.freeShippingLine?.required &&
      errors.push("送料無料条件を入力してください.");
    !this.$v.item.freeShippingLine?.numeric &&
      errors.push("数値を入力してください.");
    return errors;
  }
  /**
   * purposeNoの入力エラーメッセージを返します.
   */
  get purposeNoErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.purposeNo?.$dirty) return errors;
    !this.$v.item.purposeNo?.numeric &&
      errors.push("数値を入力してください.");
    return errors;
  }
}
